var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElementsStack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25C6 1.42163 6.67163 0.75 7.5 0.75L16.5 2.25C17.3284 2.25 18 2.92163 18 3.75H15.75L8.25 2.25C7.83582 2.25 7.5 2.58582 7.5 3V19.5C7.5 19.9142 7.83582 20.25 8.25 20.25L9.31128 20.0378L9.04688 21.4922L7.5 21.75C6.67163 21.75 6 21.0784 6 20.25V2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.75C12.6716 3.75 12 4.42157 12 5.25L9 21.75C9 22.5784 9.67157 23.25 10.5 23.25L19.5 21.75C20.3284 21.75 21 21.0784 21 20.25L24 5.25C24 4.42157 23.3284 3.75 22.5 3.75H13.5ZM14.25 5.25C13.8358 5.25 13.5 5.58579 13.5 6L10.5 21C10.5 21.4142 10.8358 21.75 11.25 21.75L18.75 20.25C19.1642 20.25 19.5 19.9142 19.5 19.5L22.5 6C22.5 5.58579 22.1642 5.25 21.75 5.25H14.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.75C3.67157 3.75 3 4.42157 3 5.25V17.25C3 18.0784 3.67157 18.75 4.5 18.75H6C7.5 18.75 7.5 18.75 7.5 18.75V5.25C7.5 4.42157 7.5 3.75 7.5 3.75H4.5ZM5.25 5.25C4.83579 5.25 4.5 5.58579 4.5 6V16.5C4.5 16.9142 4.83579 17.25 5.25 17.25H6C6 17.25 6 16.9142 6 16.5V6C6 5.58579 6 5.25 6 5.25H5.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.75C0.671573 6.75 0 7.42157 0 8.25V14.25C0 15.0784 0.671573 15.75 1.5 15.75H3C4.5 15.75 4.5 15.75 4.5 15.75V8.25C4.5 7.42157 4.5 6.75 4.5 6.75H1.5ZM2.25 8.25C1.83579 8.25 1.5 8.58579 1.5 9V13.5C1.5 13.9142 1.83579 14.25 2.25 14.25H3C3 14.25 3 13.9142 3 13.5V9C3 8.58579 3 8.25 3 8.25H2.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElementsStack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elements-stack.517c3258121e88ce5b4253a97bed88db.svg";